import { StaticImageData } from "next/image";
import Images, { Icons } from "../assets/assets";

export type TechStackFeature = {
  label: string;
  value: string;
  icon: StaticImageData | string;
};

export type TechStack = {
  id: string;
  title: string;
  graphic: StaticImageData | string;
  features: TechStackFeature[];
};

export const techStacks: TechStack[] = [
  {
    id: "java",
    title: "JAVA",
    graphic: Images?.java_graphic,
    features: [
      {
        label: "Frameworks",
        value: "Retrofit, Volley, Dagger2, Gradle, Glide",
        icon: Icons?.framework,
      },
      {
        label: "IDE",
        value: "Android Studio",
        icon: Images?.konstantLogo,
      },
      {
        label: "Database",
        value: "SQLite, Realm",
        icon: Icons?.database,
      },
    ],
  },
  {
    id: "kotlin",
    title: "KOTLIN",
    graphic: Images?.kotlin,
    features: [
      {
        label: "Frameworks",
        value: "Ktor, Jetpack Compose, Coroutines, Koin",
        icon: Icons?.framework,
      },
      {
        label: "IDE",
        value: "Android Studio, IntelliJ IDEA",
        icon: Images?.konstantLogo,
      },
      {
        label: "Database",
        value: "Room, Realm, SQLDelight",
        icon: Icons?.database,
      },
    ],
  },
  {
    id: "swift",
    title: "SWIFT",
    graphic: Images?.swift,
    features: [
      {
        label: "Frameworks",
        value: "SwiftUI, Combine, Vapor, Alamofire",
        icon: Icons?.framework,
      },
      {
        label: "IDE",
        value: "Xcode",
        icon: Images?.konstantLogo,
      },
      {
        label: "Database",
        value: "Core Data, Realm, CloudKit",
        icon: Icons?.database,
      },
    ],
  },
];
